import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import { api, config } from '../../../configs/api';
import { APP_CONFIG, getAppHeader, } from '../../../configs/config';
import { SizeTypeTokens, StackAlignItems, StackJustifyContent, StackSelfContent, StackType, StackWidth, WIDGET } from '@voltmoney/schema';
import { ACTION } from './types';
import { DigioMandateStatus, ImportScriptSrc, LENDER_ID, TATA_MANDATE_STATUS, } from '../../../configs/constants';
import { getAutoDebitDate, getBankPNGUrl, getDigioForAutoPay, horizontalStepperRepo, isFromAndroidWebview, isIframe, nextStepCredStepper, removePathFromUrlWithouReload, removeUrlWithoutReload, ShowNewMandateError } from '../../../configs/utils';
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import sharedPropsService from "../../../SharedPropsService";
import { getParameters } from '../../../configs/uri-config-utils';
let pollInterval;
let hasNavigated = false;
export const initAutoPayAction = async (action, _datastore, { navigate, navigateToBase, setDatastore, importScript, network, digio, showPopup }) => {
    const user = await SharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
        loading: true
    });
    const getMandateLinkResponse = await network.post(api.dspMandateInitiateRequest, {
        applicationId: `${applicationId}`,
        redirectionUrl: `${window?.location?.href}`,
    }, {
        headers: await getAppHeader()
    });
    if (getMandateLinkResponse?.data?.stepResponseObject?.mandateMode === "URL_REDIRECTION") {
        // this is for the new DSP flow 
        window.open(getMandateLinkResponse?.data?.stepResponseObject?.webUrl, '_self');
        await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
            loading: false
        });
    }
    else {
        await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
            loading: true
        });
        const user = await SharedPropsService.getUser();
        const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
        await navigate(ROUTE.DIGIO_AUTOPAY_INPROGRESS);
        setTimeout(async () => {
            importScript(ImportScriptSrc.DIGIO_SCRIPT, getDigioForAutoPay, async (digio_response) => {
                clearInterval(pollInterval);
                network
                    .get(`${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
                    headers: await getAppHeader(),
                })
                    .then(async (response) => {
                    if (response.status === 200 &&
                        response.data.stepResponseObject ===
                            DigioMandateStatus.COMPLETED) {
                        if (isIframe()) {
                            navigate(ROUTE.DIGIO_MANDATE_SIGN, {
                                errorOccured: false,
                                shouldRedirect: true
                            });
                        }
                        else {
                            const user = await SharedPropsService.getUser();
                            user.linkedApplications[0] =
                                response.data.updatedApplicationObj;
                            await SharedPropsService.setUser(user);
                            await showPopup({
                                type: 'SUCCESS',
                                title: 'AutoPay done successfully!',
                                subTitle: 'You will be redirected to next step \n' +
                                    'in few seconds',
                                ctaLabel: 'Continue',
                                shouldAutoNavigate: true,
                                isAutoTriggerCta: false,
                                ctaAction: {
                                    routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                    type: ACTION.SUCCESS_VERIFICATION,
                                    payload: {},
                                },
                                primary: false
                            });
                        }
                    }
                });
            }, async (digio_response) => {
                clearInterval(pollInterval);
                if (isIframe()) {
                    // ---- MANDATE ERROR CHECK CASES ---- //
                    const showNewMandateError = await ShowNewMandateError();
                    let _showExtraMandateError = false;
                    let _mandateErrorData = undefined;
                    if (showNewMandateError) {
                        await network
                            .get(showNewMandateError
                            ? `${api.digioMandateCheckRequestStatusOnCallBackV2}${applicationId}`
                            : `${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
                            headers: await getAppHeader(),
                        }).then(async (response) => {
                            if (showNewMandateError &&
                                response?.status === 200 &&
                                ((response?.data?.stepResponseObject?.status !== DigioMandateStatus.COMPLETED &&
                                    response?.data?.stepResponseObject?.status !== DigioMandateStatus.REQUESTED)) && response?.data?.stepResponseObject?.error !== null) {
                                const errorData = response?.data?.stepResponseObject.error;
                                _showExtraMandateError = true;
                                _mandateErrorData = errorData;
                                await navigateToBase(ROUTE.DIGIO_MANDATE_SIGN, {
                                    errorOccured: !_showExtraMandateError,
                                    shouldRedirect: !_showExtraMandateError,
                                    showExtraMandateError: _showExtraMandateError,
                                    mandateErrorData: _mandateErrorData
                                });
                            }
                        });
                        // ---------------------------------- //
                    }
                    else {
                        navigate(ROUTE.DIGIO_MANDATE_SIGN, {
                            errorOccured: true,
                            shouldRedirect: true
                        });
                    }
                }
                else {
                    network
                        .get(`${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
                        headers: await getAppHeader(),
                    })
                        .then(async (response) => {
                        if (response.status === 200 &&
                            response.data.stepResponseObject ===
                                DigioMandateStatus.COMPLETED) {
                            if (isIframe()) {
                                navigate(ROUTE.DIGIO_MANDATE_SIGN, {
                                    errorOccured: false,
                                    shouldRedirect: true
                                });
                            }
                            else {
                                const user = await SharedPropsService.getUser();
                                user.linkedApplications[0] =
                                    response.data.updatedApplicationObj;
                                await SharedPropsService.setUser(user);
                                await showPopup({
                                    type: 'SUCCESS',
                                    title: 'AutoPay done successfully!',
                                    subTitle: 'You will be redirected to next step \n' +
                                        'in few seconds',
                                    ctaLabel: 'Continue',
                                    shouldAutoNavigate: true,
                                    isAutoTriggerCta: false,
                                    ctaAction: {
                                        routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                        type: ACTION.SUCCESS_VERIFICATION,
                                        payload: {},
                                    },
                                    primary: false
                                });
                            }
                        }
                    });
                }
            });
            // Digio Kyc Mandate
            const user = await network.post(api.userContext, {}, {
                headers: await getAppHeader(),
            });
            const showNewMandateError = await ShowNewMandateError();
            await network
                .get(`${api.digioMandateInitiateRequest}${applicationId}`, {
                headers: await getAppHeader(),
            })
                .then(response => {
                if (response.status === 200) {
                    if (response.data && response.data.stepResponseObject) {
                        console.log('init: ', response.data);
                        const stepResponseObjectId = response.data.stepResponseObject;
                        digio.init();
                        digio.submit(stepResponseObjectId, user.data.user.phoneNumber);
                        // polling
                        pollInterval = setInterval(async () => {
                            network
                                .get(showNewMandateError
                                ? `${api.digioMandateCheckRequestStatusOnCallBackV2}${applicationId}`
                                : `${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
                                headers: await getAppHeader(),
                            }, async () => { return; }, {
                                disableDefault: true
                            })
                                .then(async (res) => {
                                if (showNewMandateError &&
                                    res?.status === 200
                                    && (res?.data?.stepResponseObject?.status !== DigioMandateStatus.COMPLETED
                                        && res?.data?.stepResponseObject?.status !== DigioMandateStatus.REQUESTED) && res?.data?.stepResponseObject?.error !== null) {
                                    clearInterval(pollInterval);
                                    const errorData = res?.data?.stepResponseObject?.error;
                                    await navigateToBase(ROUTE.DIGIO_MANDATE_SIGN, {
                                        showExtraMandateError: true,
                                        mandateErrorData: errorData
                                    });
                                    return;
                                }
                                const status = showNewMandateError
                                    ? res?.data?.stepResponseObject?.status
                                    : res?.data?.stepResponseObject;
                                if (Platform.OS !== 'web') {
                                    const options = {
                                        environment: config.DIGIO_ENVIRONMENT,
                                        theme: {
                                            primaryColor: '#234FDA',
                                            secondaryColor: '#234FDA',
                                        },
                                        is_iframe: true,
                                        logo: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
                                        fontFamily: 'Poppins',
                                        fontUrl: 'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
                                    };
                                }
                                if (res &&
                                    res.data &&
                                    status === DigioMandateStatus.COMPLETED) {
                                    const user = await SharedPropsService.getUser();
                                    user.linkedApplications[0] =
                                        response.data.updatedApplicationObj;
                                    await SharedPropsService.setUser(user);
                                    clearInterval(pollInterval);
                                    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'btnItem', {
                                        loading: false,
                                    });
                                    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, "st", {
                                        digioMandateSuccess: true
                                    });
                                }
                                else if (res &&
                                    res.data &&
                                    status === DigioMandateStatus.EXPIRED) {
                                    showPopup({
                                        type: 'FAILED',
                                        title: 'Something went wrong',
                                        // subTitle:
                                        //     "Interest charges will be deducted automatically every month.",
                                        ctaLabel: 'Try again',
                                        primary: true,
                                        // ctaAction: {
                                        //     routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                        //     type: ACTION.FAILED_VERIFICATION,
                                        //     payload: {},
                                        // },
                                    });
                                    console.log('Verification Failed');
                                    clearInterval(pollInterval);
                                    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'btnItem', {
                                        loading: false,
                                    });
                                }
                            });
                        }, 5000);
                    }
                }
            })
                .catch(error => {
                console.log(error);
            });
        }, 1000);
        await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
            loading: false
        });
    }
};
export const initAutoPayActionAndroid = async (action, _datastore, { navigate, setDatastore, importScript, network, digio, showPopup }) => {
    const user = await SharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
        mandateErrorData: undefined,
        showExtraMandateError: false,
    });
    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
        loading: true
    });
    // Digio Kyc Mandate
    await network
        .get(`${api.digioMandateInitiateRequest}${applicationId}`, {
        headers: await getAppHeader(),
    })
        .then(response => {
        if (response.status === 200) {
            if (response.data && response.data.stepResponseObject) {
                const stepperResponse = response.data.stepResponseObject;
                navigate(ROUTE.MANDATE_MODAL, {
                    stepperResponse: stepperResponse
                });
            }
        }
    })
        .catch(async (error) => {
        console.log(error);
        await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
            loading: false
        });
    });
    // await setDatastore(
    //     ROUTE.DIGIO_MANDATE_SIGN,
    //     'st', {
    //         loading: false
    //     })
};
export const goBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER, {});
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
    await hidePopup();
};
export const successVerification = async (action, _datastore, { network, navigate, removeWidgets }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    await SharedPropsService.setUser(userContextResponse.data);
    const user = await SharedPropsService.getUser();
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
    let routeObj;
    if (!hasNavigated) {
        if (await AsyncStorage.getItem("application_id") !== null) {
            routeObj = await nextStepCredStepper(updatedApplicationResponse.data.currentStepId, updatedApplicationResponse.data.stepStatusMap);
            await removeWidgets(ROUTE.DIGIO_MANDATE_SIGN, [
                { id: "st", type: WIDGET.AUTO_PAY_LANDING_PAGE }
            ]);
            await navigate(routeObj.routeId);
        }
        else {
            const currentStepId = user.linkedApplications[0].currentStepId;
            routeObj = await nextStepCredStepper(currentStepId);
            await removeWidgets(ROUTE.DIGIO_MANDATE_SIGN, [
                { id: "st", type: WIDGET.AUTO_PAY_LANDING_PAGE }
            ]);
            await navigate(routeObj.routeId);
        }
        hasNavigated = true;
    }
};
export const changeBankAccount = async (action, _datastore, { goBack, navigate, removeWidgets, navigateWithClear }) => {
    await removeWidgets(ROUTE.DIGIO_MANDATE_SIGN, [
        { id: "st", type: WIDGET.AUTO_PAY_LANDING_PAGE }
    ]);
    await navigateWithClear(ROUTE.BANK_ACCOUNT_VERIFICATION);
};
export const changeBankAccountOnMandateFailure = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
        mandateErrorData: undefined,
        showExtraMandateError: false,
        firstAutoPayFailed: true
    });
};
export const initInsideTataMandate = async (action, _datastore, { goBack, navigate, network, setDatastore, appendWidgets, removeWidgets, getHeight, asyncStorage }) => {
    let isFromJsSDK = false;
    let isFromRnSdk = false;
    let isFromiOSSDK = false;
    let platformCode = '';
    if (Platform.OS === 'web') {
        const url = window?.location?.href;
        const params = getParameters(url);
        platformCode = params?.platform || '';
        if (params?.isFromJsSDK) {
            isFromJsSDK = true;
        }
        if (params?.isFromiOSSdk) {
            isFromiOSSDK = true;
        }
        if (params?.isFromRnSdk) {
            isFromRnSdk = true;
        }
    }
    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
        loading: true
    });
    const calRedirectionUrl = () => {
        let redirectionUrl = '';
        if (isFromRnSdk || isFromiOSSDK || platformCode === "PHONEPE" /* AppPlatform.PHONEPE */) {
            redirectionUrl = window?.location?.href;
        }
        else if (platformCode === "TATADIGITAL" /* AppPlatform.TDL */) {
            redirectionUrl = `https://app.voltmoney.in/mandateCallback?redirect=true&showVoltDefaultHeader=false`;
        }
        else
            redirectionUrl = config.APP_URL;
        return redirectionUrl;
    };
    const height = getHeight();
    const stepper = await horizontalStepperRepo(network);
    const user = await SharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    const accountId = user.linkedApplications[0].accountId;
    let popupWindow;
    const getMandateLinkResponse = await network.post(api.getMandateLink, {
        applicationId: `${applicationId}`,
        originUri: calRedirectionUrl(),
        shouldRedirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() && !isFromJsSDK && !isFromiOSSDK || isFromRnSdk || platformCode === "PHONEPE" /* AppPlatform.PHONEPE */ ? true : false
    }, {
        headers: await getAppHeader()
    });
    if (getMandateLinkResponse.status === 200) {
        const tataMandateLink = getMandateLinkResponse.data.stepResponseObject;
        if (Platform.OS !== "web") {
            appendWidgets(ROUTE.DIGIO_MANDATE_SIGN, {
                repayLoanWebView: {
                    iframe: false,
                    uri: tataMandateLink,
                    width: '100%'
                },
                repayLoanStack: {
                    type: StackType.column,
                    width: StackWidth.FULL,
                    alignItems: StackAlignItems.center,
                    justifyContent: StackJustifyContent.center,
                    alignSelf: StackSelfContent.center,
                    widgetItems: [
                        { id: "spaceXXL", type: WIDGET.SPACE },
                        { id: "spaceXXL", type: WIDGET.SPACE },
                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                    ]
                },
                spaceXXL: {
                    size: SizeTypeTokens.XXL
                },
                keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
            }, [
                { id: "repayLoanStack", type: WIDGET.STACK }
            ], "contentSpace");
            removeWidgets(ROUTE.DIGIO_MANDATE_SIGN, [
                { id: "st", type: WIDGET.AUTO_PAY_LANDING_PAGE }
            ]);
        }
        else {
            const params = getParameters(window.location.href);
            const isFronRnSdk = params?.isFromRnSdk;
            if (isFromRnSdk || (platformCode === "TATADIGITAL" /* AppPlatform.TDL */ && isFromAndroidWebview())) {
                window.open(tataMandateLink, "_self");
            }
            else {
                if (isIframe() || isFromAndroidWebview() || isFromJsSDK || isFromiOSSDK) {
                    const width = 504;
                    const height = 704;
                    const left = (window.innerWidth - width) / 2;
                    const top = (window.innerHeight - height) / 2;
                    if (isFromiOSSDK) {
                        // @ts-ignore
                        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage(tataMandateLink);
                    }
                    else {
                        console.warn("IS FROM ANDROID WEBVIEW", isFromAndroidWebview(), await SharedPropsService.getAppPlatform());
                        if (isFromAndroidWebview()) {
                            if (await SharedPropsService.getIsFromNativeSDK() || isFromAndroidWebview()) {
                                popupWindow = window.open(tataMandateLink, "_parent");
                            }
                            else {
                                popupWindow = window.open(tataMandateLink, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                            }
                        }
                        else {
                            popupWindow = window.open(tataMandateLink, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                        }
                    }
                }
                else {
                    const isTATAMandateComplete = getMandateLinkResponse?.data?.updatedApplicationObj?.stepStatusMap?.TATA_MANDATE === "COMPLETED";
                    if (isTATAMandateComplete) {
                        await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, "st", {
                            mandateCallBack: true,
                            mandateState: "FINISHED"
                        });
                    }
                    else {
                        await navigate(ROUTE.DIGIO_AUTOPAY_INPROGRESS);
                        setTimeout(() => {
                            window.open(tataMandateLink, "_self");
                        }, 2000);
                    }
                }
            }
        }
        if (Platform.OS !== "web") {
            const runPollar = async () => {
                network.get(await ShowNewMandateError() ?
                    `${api.getMandateStatusV2}${applicationId}` :
                    `${api.getMandateStatus}${applicationId}`, { headers: await getAppHeader() }).then(async (response) => {
                    const showNewMandateError = await ShowNewMandateError();
                    let showExtraMandateError = false;
                    let mandateErrorData = undefined;
                    if (await ShowNewMandateError() &&
                        response?.status === 200 &&
                        response?.data?.stepResponseObject?.status !== TATA_MANDATE_STATUS.FINISHED &&
                        response?.data?.stepResponseObject?.error !== null) {
                        const errorData = response?.data?.stepResponseObject?.error;
                        showExtraMandateError = true;
                        mandateErrorData = errorData;
                    }
                    const status = showNewMandateError
                        ? response?.data?.stepResponseObject?.status?.toUpperCase()?.trim()
                        : response?.data?.stepResponseObject?.toUpperCase()?.trim();
                    if (status !== "IN PROGRESS") {
                        clearInterval(timer);
                        removeWidgets(ROUTE.DIGIO_MANDATE_SIGN, [
                            { id: "repayLoanStack", type: WIDGET.STACK },
                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                            { id: "keyboardSpace", type: WIDGET.SPACE },
                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                        ]);
                        const response = await network
                            .get(`${api.userProfile}${accountId}`, { headers: await getAppHeader() });
                        // @ts-ignore
                        const bankDetails = await response?.data?.bankDetails;
                        const bankCode = await bankDetails?.bankCode;
                        const autoDebitDate = await getAutoDebitDate(network);
                        await appendWidgets(ROUTE.DIGIO_MANDATE_SIGN, {
                            st: {
                                height: height,
                                stepperData: stepper,
                                changeBankAccount: {
                                    type: ACTION.CHANGE_BANK_ACCOUNT,
                                    route: ROUTE.DIGIO_MANDATE_SIGN,
                                    payload: {}
                                },
                                mandateState: status,
                                mandateCallBack: showExtraMandateError ? false : true,
                                goToDigioAction: {
                                    type: ACTION.INIT_TATA_MANDATE,
                                    payload: {},
                                    routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                },
                                bankDetails: bankDetails,
                                bankUrl: getBankPNGUrl(bankCode),
                                backAction: {
                                    type: ACTION.GO_BACK,
                                    routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                    payload: {}
                                },
                                continuePress: {
                                    type: ACTION.SUCCESS_VERIFICATION,
                                    routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                    payload: {}
                                },
                                contactUsAction: {
                                    type: ACTION.CONTACT_US_CARD,
                                    routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                    payload: {}
                                },
                                isRedirected: false,
                                isSuccessful: showExtraMandateError ? false : true,
                                autoDebitDate: autoDebitDate,
                                showExtraMandateError: showExtraMandateError,
                                mandateErrorData: mandateErrorData
                            },
                        }, [{ id: 'st', type: WIDGET.AUTO_PAY_LANDING_PAGE }], "contentSpace1");
                    }
                });
            };
            const timer = setInterval(() => {
                runPollar();
            }, APP_CONFIG.POLLING_INTERVAL);
        }
        else if (isIframe() || isFromAndroidWebview() || isFromJsSDK || isFromiOSSDK) {
            const runPollar = async () => {
                const isFromNativeSDK = await SharedPropsService.getIsFromNativeSDK();
                const showNewMandateError = await ShowNewMandateError();
                // @ts-ignore
                network.get(showNewMandateError ?
                    `${api.getMandateStatusV2}${applicationId}` :
                    `${api.getMandateStatus}${applicationId}`, { headers: await getAppHeader() }).then((response) => {
                    if (popupWindow?.closed) {
                        clearInterval(timer);
                    }
                    const status = showNewMandateError
                        ? response?.data?.stepResponseObject?.status?.toUpperCase()?.trim()
                        : response?.data?.stepResponseObject?.toUpperCase()?.trim();
                    if (status !== TATA_MANDATE_STATUS.IN_PROGRESS.toUpperCase()) {
                        // @ts-ignore
                        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closePop");
                        if (isFromNativeSDK || isFromAndroidWebview()) {
                            window.open("closePop", "_parent");
                        }
                        else {
                            popupWindow?.close();
                        }
                        // @ts-ignore
                        clearInterval(timer);
                        if (showNewMandateError &&
                            response?.status === 200 &&
                            status !== TATA_MANDATE_STATUS.IN_PROGRESS?.toUpperCase() &&
                            response?.data?.stepResponseObject?.error !== null) {
                            const errorData = response?.data?.stepResponseObject?.error;
                            setDatastore(ROUTE.DIGIO_MANDATE_SIGN, "st", {
                                showExtraMandateError: true,
                                mandateErrorData: errorData
                            });
                            return;
                        }
                        // ---------------------------------- //
                        setDatastore(ROUTE.DIGIO_MANDATE_SIGN, "st", {
                            mandateCallBack: true,
                            mandateState: status
                        });
                    }
                });
            };
            const timer = setInterval(() => {
                runPollar();
            }, APP_CONFIG.POLLING_INTERVAL);
        }
    }
    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
        loading: false
    });
};
export const contactUsAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const contactUsActionFromBE = async (action, _datastore, { navigate, setDatastore }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const mandateCallback = async (action, _datastore, { setDatastore, network }) => {
    const url = Platform.OS === 'web' ? window.location.href : '';
    const tataMandateCallback = url.toString().includes('mandateCallback');
    const user = await SharedPropsService.getUser();
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        const user = await SharedPropsService.getUser();
        applicationId = user.linkedApplications[0].applicationId;
    }
    if (Platform.OS === "web") {
        if (tataMandateCallback) {
            const getStatusOfMandate = await network.get(await ShowNewMandateError() ?
                `${api.getMandateStatusV2}${applicationId}`
                : `${api.getMandateStatus}${applicationId}`, {
                headers: await getAppHeader()
            });
            // ------------ MANDATE CUSTOM ERROR BLOCK ------------- //
            if (await ShowNewMandateError() &&
                getStatusOfMandate?.status === 200 &&
                getStatusOfMandate?.data?.stepResponseObject?.status !== TATA_MANDATE_STATUS.FINISHED &&
                getStatusOfMandate?.data?.stepResponseObject?.error !== null) {
                const errorData = getStatusOfMandate?.data?.stepResponseObject?.error;
                setTimeout(async () => {
                    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
                        showExtraMandateError: true,
                        mandateErrorData: errorData
                    });
                }, 250);
                removeUrlWithoutReload("mandateCallback");
                removeUrlWithoutReload("appId");
                removeUrlWithoutReload("redirect");
                removeUrlWithoutReload("showVoltDefaultHeader");
                removePathFromUrlWithouReload("mandateCallback");
                return;
            }
            // ----------------------------------------------------- //
            if (await ShowNewMandateError()) {
                await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, "st", {
                    mandateCallBack: true,
                    mandateState: getStatusOfMandate.data.stepResponseObject.status.toUpperCase()
                });
            }
            else {
                await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, "st", {
                    mandateCallBack: true,
                    mandateState: getStatusOfMandate.data.stepResponseObject.toUpperCase()
                });
            }
            if (Platform.OS === "web") {
                removeUrlWithoutReload("mandateCallback");
                removeUrlWithoutReload("appId");
                removeUrlWithoutReload("redirect");
                removeUrlWithoutReload("showVoltDefaultHeader");
                removePathFromUrlWithouReload("mandateCallback");
            }
        }
    }
};
export const needHelpAction = async (action, datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const retryMandate = async (action, datastore, utilities) => {
    console.log('*** retryMandate Action triggered ***');
    const user = await sharedPropsService.getUser();
    const lenderId = user?.linkedApplications[0]?.lenderAccountId;
    await utilities.setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
        mandateErrorData: undefined,
        showExtraMandateError: false,
    });
    if (lenderId.toLowerCase() === LENDER_ID.BAJAJ || lenderId.toLowerCase() === LENDER_ID.DSP) {
        if (Platform.OS !== 'web') {
            await initAutoPayActionAndroid(action, datastore, utilities);
        }
        else {
            await initAutoPayAction(action, datastore, utilities);
        }
    }
    else {
        // FOR LENDER TATA
        await initInsideTataMandate(action, datastore, utilities);
    }
};
export const resetErrorModal = async (action, datastore, { navigate, setDatastore }) => {
    await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'st', {
        digioMandateCancelled: false,
    });
};
export const hasMandateCallback = () => {
    // Get URL either from parameter or window location
    const url = window.location.href;
    // Check if the input is a valid string
    if (typeof url !== 'string') {
        return false;
    }
    // Case insensitive check for 'mandateCallback' in the URL
    return url.toLowerCase().includes('mandatecallback');
};
